import request from '@/utils/httpRequest'
/*
 * @author: xz
 * @date: 2021-07-15
 * */
/*
 * @Description: 是否是志愿者
 * */
export function isVolunteer (fid) {
  return request({
    url: '/api/volunteer/token/isRegistered?fid=' + fid,
    method: 'get'
  })
}
/*
 * @Description: 注册志愿者
 * */
export function registerVolunteer (query) {
  return request({
    url: '/api/volunteer/token/registered',
    method: 'post',
    data: query
  })
}

/*
 * @Description: 志愿者
 * */
export function VolunteerList (query) {
  return request({
    url: '/api/volunteer/web/volunteer/page',
    method: 'get',
    params: query
  })
}
/*
 * @Description: 志愿者详情
 * */
export function Volunteerdetail (id) {
  return request({
    url: '/api/volunteer/web/volunteer/' + id,
    method: 'get'
  })
}

/*
 * @Description: 志愿者里团队列表
 * */
export function VolunteergroupList (id, query) {
  return request({
    url: '/api/volunteer/web/volunteer/myGroup?volunteerId=' + id,
    method: 'get',
    params: query
  })
}

/*
 * @Description: 志愿者里活动列表
 * */
export function VolunteeractivityList (id, query) {
  return request({
    url: '/api/volunteer/web/volunteer/myAppointment?volunteerId=' + id,
    method: 'get',
    params: query
  })
}
/*
 * @Description: 志愿团队注册
 * */
export function registervcommunity (query) {
  return request({
    url: '/api/volunteer/token/groupRegistered',
    method: 'post',
    data: query
  })
}

/*
 * @Description: 加入志愿团队
 * */
export function joincommunity (id) {
  return request({
    url: '/api/volunteer/token/joinGroup?groupId=' + id,
    method: 'get'
  })
}

/*
 * @Description: 志愿团队
 * */
export function VolunteercommunityList (query) {
  return request({
    url: '/api/volunteer/web/volunteerGroup/page',
    method: 'get',
    params: query
  })
}

/*
 * @Description: 志愿团队详情
 * */
export function VolunteercommunityDetail (id) {
  return request({
    url: '/api/volunteer/web/volunteerGroup/' + id,
    method: 'get'
  })
}

/*
 * @Description: 志愿团队活动列表
 * */
export function vcommunityactivity (id, query) {
  return request({
    url: '/api/volunteer/web/groupApp/' + id,
    method: 'get',
    params: query
  })
}
/*
 * @Description: 志愿活动列表
 * */
export function vactivityList (query) {
  return request({
    url: '/api/volunteer/web/appointment/page',
    method: 'get',
    params: query
  })
}
/*
 * @Description: 志愿活动详情
 * */
export function vactivityDetail (id) {
  return request({
    url: '/api/volunteer/web/appointment/' + id,
    method: 'get'
  })
}
/*
 * @Description: 志愿活动报名
 * */
export function addvactivity (id) {
  return request({
    url: '/api/volunteer/token/joinActivity?activityId=' + id,
    method: 'get'
  })
}
/*
 * @Description: 服务风采列表
 * */
export function activitystyle (query) {
  return request({
    url: '/api/volunteer/web/activityStyle/page',
    method: 'get',
    params: query
  })
}
/*
 * @Description: 服务风采列表
 * */
export function activitystyledetail (id) {
  return request({
    url: '/api/volunteer/web/activityStyle/' + id,
    method: 'get'
  })
}

/*
 * @Description: 志愿者，志愿者团队，志愿者活动已审核的数量
 * */
export function volunteerdata (fid) {
  return request({
    url: '/api/volunteer/web/getFirstData?fid=' + fid,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/volunteer/index.js